// src/services/UserService.ts
import {
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
  addDoc,
  deleteDoc,
  query,
  where,
  Timestamp,
} from "firebase/firestore";
import { UserProfile } from "@visitproof/types";
import { db } from "../firebase";
import { clean } from "../utils/utils";

const userCollectionRef = collection(db, "users");

export const UserService = {
  async createUser(
    userData: Omit<UserProfile, "id" | "createdAt" | "updatedAt">,
  ): Promise<string> {
    const newUser: Omit<UserProfile, "id"> = {
      ...userData,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now(),
    };

    const userRef = await addDoc(userCollectionRef, newUser);
    return userRef.id;
  },

  async getUser(userId: string): Promise<UserProfile | null> {
    const userDoc = await getDoc(doc(userCollectionRef, userId));
    if (userDoc.exists()) {
      return { id: userDoc.id, ...userDoc.data() } as UserProfile;
    }
    return null;
  },

  async getAllUsers(accountId: string): Promise<UserProfile[]> {
    const userSnapshot = await getDocs(
      query(userCollectionRef, where("accountId", "==", accountId)),
    );
    return userSnapshot.docs.map(
      (doc) => ({ id: doc.id, ...doc.data() }) as UserProfile,
    );
  },

  async updateUser(
    userId: string,
    updatedData: Partial<Omit<UserProfile, "id" | "createdAt">>,
  ): Promise<void> {
    const userDocRef = doc(userCollectionRef, userId);
    await updateDoc(userDocRef, clean({
      ...updatedData,
      updatedAt: Timestamp.now(),
    }));
  },

  async deleteUser(userId: string): Promise<void> {
    const userDocRef = doc(userCollectionRef, userId);
    await deleteDoc(userDocRef);
  },
};
